/* global jQuery*/

import { Module } from 'wrapper6'

export default class Postfix extends Module {
  ready (app) {
    this.handlePostFixes()
  }

  handlePostFixes () {
    const that = this
    jQuery(document).on('keyup change', '.postfix-input', function (e) {
      const input = jQuery(e.currentTarget)
      const postfix = input.parent().find('span.postfix')
      that.updateSuffix(input, postfix)
    })
  }

  updateSuffix (input, postfix) {
    const width = this.getTextWidth(input.val(), '16px "canada-type-gibson", sans-serif')
    postfix.css('left', (width + 16) + 'px')
  }

  /**
   * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
   *
   * @param {String} text The text to be rendered.
   * @param {String} font The css font descriptor that text is to be rendered with (e.g. "bold 14px verdana").
   *
   * @see https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
   */
  getTextWidth (text, font) {
    // re-use canvas object for better performance
    const canvas = this.getTextWidth.canvas || (this.getTextWidth.canvas = document.createElement('canvas'))
    const context = canvas.getContext('2d')
    context.font = font
    const metrics = context.measureText(text)
    return metrics.width
  }
}
